import React from "react";
import { Button } from "reactstrap";

const DPlusButtonAdd = ({ title = "Ajouter", handleClick, icon }) => {
  const handleButtonClick = () => {
    handleClick();
  };
  return (
    <div>
      <Button color={"success"} style={{ boxShadow: "3px 3px 3px grey" }} onClick={handleButtonClick}>
        {icon ? (
          <>
            <i className={icon} />
            {title}
          </>
        ) : (
          title
        )}
      </Button>
    </div>
  );
};

export default DPlusButtonAdd;
